import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GoogleScholar from '@mui/icons-material/School';
import '../assets/styles/Main.scss';
import profile from '../assets/images/profile-pic.jpg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profile} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/0x365" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/robert-cowlishaw/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://scholar.google.com/citations?user=vIQ1FBcAAAAJ&hl=en" target="_blank" rel="noreferrer"><GoogleScholar/></a>
          </div>
          <h1>Robert Cowlishaw</h1>
          <p>Full Stack Software and Aerospace Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/0x365" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/robert-cowlishaw/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://scholar.google.com/citations?user=vIQ1FBcAAAAJ&hl=en" target="_blank" rel="noreferrer"><GoogleScholar/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;